<!-- Declared order is preserved: the model ranks the figures, and reading order carries that. -->
<div class="stats">
    @for (stat of block().stats; track $index) {
        <div
            class="stat"
            [class.stat-critical]="stat.status === 'critical'"
            [class.stat-warning]="stat.status === 'warning'"
            [class.stat-ok]="stat.status === 'ok'"
            [class.stat-info]="stat.status === 'info'"
        >
            <span class="stat-value">
                {{ stat.value | number }}
                @if (stat.unit) {
                    <span class="stat-unit">{{ stat.unit }}</span>
                }
            </span>
            @if (stat.status) {
                <copilot-rich-block-status [status]="stat.status" />
            }
            <p class="stat-label">{{ stat.label }}</p>
        </div>
    }
</div>
